import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Shell from './components/layout/Shell';
import Home from './pages/Home';
import Whiteboard from './components/tools/Whiteboard';
import Geoboard from './components/tools/Geoboard';
import Login from './pages/Login';
import LineClassification from './features/geometry/LineClassification';
import Symmetry from './features/geometry/Symmetry';
import Settings from './pages/Settings';
import Achievements from './pages/Achievements';
import Polygons from './features/geometry/Polygons';
import CuerposGeometricos from './features/geometry/CuerposGeometricos';

const Units = () => (
    <div className="p-8">
        <h2 className="text-3xl font-bold text-brand-purple mb-8">Unidades de Aprendizaje</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Link to="1" className="bg-white p-6 rounded-3xl shadow-lg border-b-4 border-gray-200 hover:scale-105 transition-transform group cursor-pointer block">
                <div className="text-6xl mb-4 group-hover:scale-110 transition-transform">📏</div>
                <h3 className="text-xl font-bold text-gray-800">Unidad 1: Líneas</h3>
                <p className="text-gray-500 text-sm mt-2">Rectas, curvas, poligonales, paralelas...</p>
                <div className="mt-4 bg-brand-blue/10 text-brand-blue font-bold py-2 px-4 rounded-xl text-center">
                    ¡Entrar! 🚀
                </div>
            </Link>

            <Link to="2" className="bg-white p-6 rounded-3xl shadow-lg border-b-4 border-gray-200 hover:scale-105 transition-transform group cursor-pointer block">
                <div className="text-6xl mb-4 group-hover:scale-110 transition-transform">🔷</div>
                <h3 className="text-xl font-bold text-gray-800">Unidad 2: Polígonos</h3>
                <p className="text-gray-500 text-sm mt-2">Lados, vértices y nombres de las figuras.</p>
                <div className="mt-4 bg-brand-orange/10 text-brand-orange font-bold py-2 px-4 rounded-xl text-center">
                    ¡Entrar! 🚀
                </div>
            </Link>

            <Link to="3" className="bg-white p-6 rounded-3xl shadow-lg border-b-4 border-gray-200 hover:scale-105 transition-transform group cursor-pointer block">
                <div className="text-6xl mb-4 group-hover:scale-110 transition-transform">🔶</div>
                <h3 className="text-xl font-bold text-gray-800">Unidad 3: Cuerpos Geométricos</h3>
                <p className="text-gray-500 text-sm mt-2">Prismas, pirámides, cilindros, conos y esferas.</p>
                <div className="mt-4 bg-brand-green/10 text-brand-green font-bold py-2 px-4 rounded-xl text-center">
                    ¡Entrar! 🚀
                </div>
            </Link>
        </div>
    </div>
);

const AppRoutes = () => {
    const { user } = useAuth();

    return (
        <Routes>
            {!user ? (
                <Route path="*" element={<Login />} />
            ) : (
                <Route path="/" element={<Shell />}>
                    <Route index element={<Home />} />
                    <Route path="units" element={<Units />} />
                    <Route path="units/1" element={<LineClassification />} />
                    <Route path="units/2" element={<Polygons />} />
                    <Route path="units/3" element={<CuerposGeometricos />} />
                    <Route path="units/1/symmetry" element={<Symmetry />} />
                    <Route path="whiteboard" element={<Whiteboard />} />
                    <Route path="geoboard" element={<Geoboard />} />
                    <Route path="achievements" element={<Achievements />} />
                    <Route path="settings" element={<Settings />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            )}
        </Routes>
    );
};

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <AppRoutes />
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
